import { styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import { useTheme } from 'react-native-paper';

import { OEText } from '../oe-text/oe-text';

export interface CopyrightProps {
  children: string;
  style?: StyleProp<ViewStyle>;
  textColor?: string;
}

const Copyright = ({ children, style, textColor }: CopyrightProps) => {
  const { colors } = useTheme();
  return (
    <Container style={style}>
      <OEText
        fontSize={16}
        textAlign="center"
        color={colors.dark3 || textColor}
      >
        {children}
      </OEText>
    </Container>
  );
};

const Container = styled.View`
  background-color: ${({ theme }) => theme.color.backgroundGray};
  padding: 28px 34px;
`;

export { Copyright };
